import { FunctionalComponent } from 'preact'
// Too much files to change
// eslint-disable-next-line import/no-internal-modules
import ClampLines from '../../../../preact-components/clamp-lines/ClampLines'
// Too much files to change
// eslint-disable-next-line import/no-internal-modules
import htmlParser from '../../../../preact-components/utils/htmlParser'

export interface CardWidgetTextProps {
  html: string
}

export const CardWidgetText: FunctionalComponent<CardWidgetTextProps> = ({ html }) => (
  <p className='card-widget-text'>
    <ClampLines id='featured-topic-view' lines={3} text={htmlParser.stripHtml(html) || ''} />
  </p>
)
